// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Calendar  {
    _originalTypeClassName = "Loom.BO.Calendar";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Calendar.translate = translateService;
}
this.CalendarEvent = [];
this.Id = null;
this.Name = null;
this.Type = null;
this.Description = null;
this.Visibility = null;
this.CalendarProperty1 = null;
this._key = this.Id = ""; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Type:any;
Description:any;
Visibility:any;
CalendarProperty1:any;
CalendarEvent:any;
static setCalendarEvent = ($this, items) => {
                if (items == null) items = [];
                if ($this.CalendarEvent == null) $this.CalendarEvent = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CalendarEvent.length > 0) {
                    Domain.Calendar.removeCalendarEvent($this, $this.CalendarEvent[0]);
                }

                Domain.Calendar.addManyCalendarEvent($this, copyItems);
            }
static addManyCalendarEvent = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Calendar.addCalendarEvent($this, items[i]);
                }
            }
static addCalendarEvent = ($this, item) => {
                if ($this.CalendarEvent == null) $this.CalendarEvent = [];
                if (item == null || $this.CalendarEvent.indexOf(item) > -1) return;
                $this.CalendarEvent.push(item);
if (item.Calendar != $this) {
Domain.CalendarEvent.setCalendar(item, $this);
}
}
static addRangeCalendarEvent = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Calendar.addCalendarEvent($this, item));
            }
static removeCalendarEvent = ($this, item) => {
                if ($this == null || $this.CalendarEvent == null || $this.CalendarEvent.indexOf(item) === -1) return;
                var _index = $this.CalendarEvent.indexOf(item);
                $this.CalendarEvent.splice(_index, 1);
item.Calendar = null;
}
static clearCalendarEvent = ($this) => { $this.CalendarEvent = null; }

static CreateCalendar(name: any,type: any,description: any,property1: any,visibility: any): any{let cal = new Domain.Calendar();
cal.Id = type + ":" + name + ":" + property1;
cal.Name = name;
cal.Type = type;
cal.Description = description;
cal.Visibility = visibility;
cal.CalendarProperty1 = property1;
return cal;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == "";
            }


}